import { IOptimizerResult } from '../../interfaces';

export const optimizationResult: IOptimizerResult = {
    routeObj: JSON.parse(
        '[{"vehicleId":15777,"route":[{"tipo":"Cliente","id":162428925,"hora":{"horas":9,"minutos":0}},{"tipo":"Cliente","id":162428911,"hora":{"horas":9,"minutos":15}},{"tipo":"Cliente","id":162428882,"hora":{"horas":9,"minutos":29}},{"tipo":"Cliente","id":162428908,"hora":{"horas":9,"minutos":51}},{"tipo":"Cliente","id":162428918,"hora":{"horas":10,"minutos":10}},{"tipo":"Cliente","id":162428902,"hora":{"horas":14,"minutos":0}},{"tipo":"Cliente","id":162428899,"hora":{"horas":14,"minutos":9}},{"tipo":"Cliente","id":162428854,"hora":{"horas":14,"minutos":21}}],"startTime":{"horas":7,"minutos":0}},{"vehicleId":117112,"route":[{"tipo":"Cliente","id":162428844,"hora":{"horas":9,"minutos":0}},{"tipo":"Cliente","id":162428859,"hora":{"horas":9,"minutos":12}},{"tipo":"Cliente","id":162428871,"hora":{"horas":9,"minutos":21}},{"tipo":"Cliente","id":162428935,"hora":{"horas":9,"minutos":33}},{"tipo":"Cliente","id":162428874,"hora":{"horas":9,"minutos":38}}],"startTime":{"horas":7,"minutos":0}},{"vehicleId":117115,"route":[{"tipo":"Cliente","id":162428919,"hora":{"horas":23,"minutos":8}},{"tipo":"Cliente","id":162428913,"hora":{"horas":23,"minutos":15}},{"tipo":"Cliente","id":162428866,"hora":{"horas":23,"minutos":26}},{"tipo":"Cliente","id":162428930,"hora":{"horas":23,"minutos":36}},{"tipo":"Cliente","id":162428894,"hora":{"horas":23,"minutos":43}}],"startTime":{"horas":23,"minutos":0}},{"vehicleId":5903,"route":[{"tipo":"Cliente","id":162428886,"hora":{"horas":9,"minutos":36}}],"startTime":{"horas":8,"minutos":52}},{"vehicleId":117106,"route":[{"tipo":"Cliente","id":162428858,"hora":{"horas":9,"minutos":0}},{"tipo":"Cliente","id":162428915,"hora":{"horas":9,"minutos":6}},{"tipo":"Cliente","id":162428855,"hora":{"horas":9,"minutos":15}},{"tipo":"Cliente","id":162428862,"hora":{"horas":9,"minutos":32}},{"tipo":"Cliente","id":162428868,"hora":{"horas":9,"minutos":38}},{"tipo":"Cliente","id":162428932,"hora":{"horas":9,"minutos":43}},{"tipo":"Cliente","id":162428870,"hora":{"horas":9,"minutos":48}},{"tipo":"Cliente","id":162428937,"hora":{"horas":9,"minutos":55}},{"tipo":"Cliente","id":162428892,"hora":{"horas":10,"minutos":6}},{"tipo":"Cliente","id":162428883,"hora":{"horas":10,"minutos":12}},{"tipo":"Cliente","id":162428889,"hora":{"horas":10,"minutos":20}},{"tipo":"Cliente","id":162428938,"hora":{"horas":10,"minutos":31}},{"tipo":"Cliente","id":162428928,"hora":{"horas":10,"minutos":40}},{"tipo":"Cliente","id":162428867,"hora":{"horas":10,"minutos":45}},{"tipo":"Cliente","id":162428929,"hora":{"horas":10,"minutos":50}},{"tipo":"Cliente","id":162428852,"hora":{"horas":11,"minutos":1}},{"tipo":"Cliente","id":162428914,"hora":{"horas":11,"minutos":20}},{"tipo":"Cliente","id":162428880,"hora":{"horas":11,"minutos":34}},{"tipo":"Cliente","id":162428842,"hora":{"horas":14,"minutos":0}},{"tipo":"Cliente","id":162428905,"hora":{"horas":14,"minutos":22}},{"tipo":"Cliente","id":162428872,"hora":{"horas":15,"minutos":25}},{"tipo":"Cliente","id":162428933,"hora":{"horas":15,"minutos":30}},{"tipo":"Cliente","id":162428875,"hora":{"horas":15,"minutos":36}},{"tipo":"Cliente","id":162428877,"hora":{"horas":16,"minutos":0}},{"tipo":"Cliente","id":162428926,"hora":{"horas":16,"minutos":8}},{"tipo":"Cliente","id":162428857,"hora":{"horas":16,"minutos":19}},{"tipo":"Cliente","id":162428849,"hora":{"horas":16,"minutos":27}},{"tipo":"Cliente","id":162428848,"hora":{"horas":16,"minutos":32}},{"tipo":"Cliente","id":162428845,"hora":{"horas":16,"minutos":38}},{"tipo":"Cliente","id":162428920,"hora":{"horas":16,"minutos":51}},{"tipo":"Cliente","id":162428939,"hora":{"horas":16,"minutos":59}},{"tipo":"Cliente","id":162428907,"hora":{"horas":17,"minutos":5}},{"tipo":"Cliente","id":162428923,"hora":{"horas":17,"minutos":13}},{"tipo":"Cliente","id":162428861,"hora":{"horas":17,"minutos":21}},{"tipo":"Cliente","id":162428904,"hora":{"horas":17,"minutos":29}}],"startTime":{"horas":7,"minutos":0}},{"vehicleId":116066,"route":[{"tipo":"Cliente","id":162428843,"hora":{"horas":9,"minutos":0}},{"tipo":"Cliente","id":162428846,"hora":{"horas":9,"minutos":7}},{"tipo":"Cliente","id":162428900,"hora":{"horas":9,"minutos":16}},{"tipo":"Cliente","id":162428847,"hora":{"horas":9,"minutos":21}},{"tipo":"Cliente","id":162428901,"hora":{"horas":9,"minutos":26}},{"tipo":"Cliente","id":162428850,"hora":{"horas":9,"minutos":33}},{"tipo":"Cliente","id":162428856,"hora":{"horas":9,"minutos":41}},{"tipo":"Cliente","id":162428853,"hora":{"horas":9,"minutos":48}},{"tipo":"Cliente","id":162428934,"hora":{"horas":9,"minutos":59}},{"tipo":"Cliente","id":162428873,"hora":{"horas":10,"minutos":4}},{"tipo":"Cliente","id":162428917,"hora":{"horas":10,"minutos":17}},{"tipo":"Cliente","id":162428897,"hora":{"horas":10,"minutos":26}},{"tipo":"Cliente","id":162428895,"hora":{"horas":10,"minutos":31}},{"tipo":"Cliente","id":162428887,"hora":{"horas":14,"minutos":0}},{"tipo":"Cliente","id":162428896,"hora":{"horas":14,"minutos":6}},{"tipo":"Cliente","id":162428893,"hora":{"horas":14,"minutos":16}},{"tipo":"Cliente","id":162428890,"hora":{"horas":14,"minutos":21}},{"tipo":"Cliente","id":162428885,"hora":{"horas":14,"minutos":26}},{"tipo":"Cliente","id":162428916,"hora":{"horas":14,"minutos":34}},{"tipo":"Cliente","id":162428906,"hora":{"horas":14,"minutos":41}},{"tipo":"Cliente","id":162428888,"hora":{"horas":14,"minutos":48}},{"tipo":"Cliente","id":162428903,"hora":{"horas":14,"minutos":57}},{"tipo":"Cliente","id":162428881,"hora":{"horas":15,"minutos":5}},{"tipo":"Cliente","id":162428879,"hora":{"horas":15,"minutos":12}},{"tipo":"Cliente","id":162428876,"hora":{"horas":15,"minutos":19}},{"tipo":"Cliente","id":162428860,"hora":{"horas":15,"minutos":30}},{"tipo":"Cliente","id":162428910,"hora":{"horas":15,"minutos":36}},{"tipo":"Cliente","id":162428851,"hora":{"horas":15,"minutos":43}},{"tipo":"Cliente","id":162428878,"hora":{"horas":15,"minutos":54}},{"tipo":"Cliente","id":162428884,"hora":{"horas":16,"minutos":2}},{"tipo":"Cliente","id":162428922,"hora":{"horas":16,"minutos":13}}],"startTime":{"horas":7,"minutos":0}},{"vehicleId":117096,"route":[{"tipo":"Cliente","id":162428898,"hora":{"horas":9,"minutos":0}},{"tipo":"Cliente","id":162428864,"hora":{"horas":9,"minutos":59}},{"tipo":"Cliente","id":162428912,"hora":{"horas":10,"minutos":15}},{"tipo":"Cliente","id":162428931,"hora":{"horas":10,"minutos":34}},{"tipo":"Cliente","id":162428891,"hora":{"horas":11,"minutos":9}},{"tipo":"Cliente","id":162428869,"hora":{"horas":14,"minutos":0}},{"tipo":"Cliente","id":162428865,"hora":{"horas":16,"minutos":0}},{"tipo":"Cliente","id":162428936,"hora":{"horas":16,"minutos":19}},{"tipo":"Cliente","id":162428924,"hora":{"horas":16,"minutos":48}},{"tipo":"Cliente","id":162428921,"hora":{"horas":16,"minutos":59}},{"tipo":"Cliente","id":162428909,"hora":{"horas":17,"minutos":29}},{"tipo":"Cliente","id":162428863,"hora":{"horas":19,"minutos":37}},{"tipo":"Cliente","id":162428927,"hora":{"horas":21,"minutos":56}}],"startTime":{"horas":7,"minutos":0}}]',
    ),
    asignacion: {
        '5903': {
            pedidos: [
                {
                    tipo: 'Cliente',
                    id: 162428886,
                    hora: {
                        horas: 9,
                        minutos: 36,
                    },
                },
            ],
            pedidosOrdenados: [
                {
                    tipo: 'Cliente',
                    id: 162428886,
                    hora: {
                        horas: 9,
                        minutos: 36,
                    },
                },
            ],
            startTime: {
                horas: 8,
                minutos: 52,
            },
        },
        '15777': {
            pedidos: [
                {
                    tipo: 'Cliente',
                    id: 162428925,
                    hora: {
                        horas: 9,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428911,
                    hora: {
                        horas: 9,
                        minutos: 15,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428882,
                    hora: {
                        horas: 9,
                        minutos: 29,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428908,
                    hora: {
                        horas: 9,
                        minutos: 51,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428918,
                    hora: {
                        horas: 10,
                        minutos: 10,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428902,
                    hora: {
                        horas: 14,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428899,
                    hora: {
                        horas: 14,
                        minutos: 9,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428854,
                    hora: {
                        horas: 14,
                        minutos: 21,
                    },
                },
            ],
            pedidosOrdenados: [
                {
                    tipo: 'Cliente',
                    id: 162428925,
                    hora: {
                        horas: 9,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428911,
                    hora: {
                        horas: 9,
                        minutos: 15,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428882,
                    hora: {
                        horas: 9,
                        minutos: 29,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428908,
                    hora: {
                        horas: 9,
                        minutos: 51,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428918,
                    hora: {
                        horas: 10,
                        minutos: 10,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428902,
                    hora: {
                        horas: 14,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428899,
                    hora: {
                        horas: 14,
                        minutos: 9,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428854,
                    hora: {
                        horas: 14,
                        minutos: 21,
                    },
                },
            ],
            startTime: {
                horas: 7,
                minutos: 0,
            },
        },
        '116066': {
            pedidos: [
                {
                    tipo: 'Cliente',
                    id: 162428843,
                    hora: {
                        horas: 9,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428846,
                    hora: {
                        horas: 9,
                        minutos: 7,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428900,
                    hora: {
                        horas: 9,
                        minutos: 16,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428847,
                    hora: {
                        horas: 9,
                        minutos: 21,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428901,
                    hora: {
                        horas: 9,
                        minutos: 26,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428850,
                    hora: {
                        horas: 9,
                        minutos: 33,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428856,
                    hora: {
                        horas: 9,
                        minutos: 41,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428853,
                    hora: {
                        horas: 9,
                        minutos: 48,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428934,
                    hora: {
                        horas: 9,
                        minutos: 59,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428873,
                    hora: {
                        horas: 10,
                        minutos: 4,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428917,
                    hora: {
                        horas: 10,
                        minutos: 17,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428897,
                    hora: {
                        horas: 10,
                        minutos: 26,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428895,
                    hora: {
                        horas: 10,
                        minutos: 31,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428887,
                    hora: {
                        horas: 14,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428896,
                    hora: {
                        horas: 14,
                        minutos: 6,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428893,
                    hora: {
                        horas: 14,
                        minutos: 16,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428890,
                    hora: {
                        horas: 14,
                        minutos: 21,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428885,
                    hora: {
                        horas: 14,
                        minutos: 26,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428916,
                    hora: {
                        horas: 14,
                        minutos: 34,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428906,
                    hora: {
                        horas: 14,
                        minutos: 41,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428888,
                    hora: {
                        horas: 14,
                        minutos: 48,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428903,
                    hora: {
                        horas: 14,
                        minutos: 57,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428881,
                    hora: {
                        horas: 15,
                        minutos: 5,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428879,
                    hora: {
                        horas: 15,
                        minutos: 12,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428876,
                    hora: {
                        horas: 15,
                        minutos: 19,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428860,
                    hora: {
                        horas: 15,
                        minutos: 30,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428910,
                    hora: {
                        horas: 15,
                        minutos: 36,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428851,
                    hora: {
                        horas: 15,
                        minutos: 43,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428878,
                    hora: {
                        horas: 15,
                        minutos: 54,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428884,
                    hora: {
                        horas: 16,
                        minutos: 2,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428922,
                    hora: {
                        horas: 16,
                        minutos: 13,
                    },
                },
            ],
            pedidosOrdenados: [
                {
                    tipo: 'Cliente',
                    id: 162428843,
                    hora: {
                        horas: 9,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428846,
                    hora: {
                        horas: 9,
                        minutos: 7,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428900,
                    hora: {
                        horas: 9,
                        minutos: 16,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428847,
                    hora: {
                        horas: 9,
                        minutos: 21,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428901,
                    hora: {
                        horas: 9,
                        minutos: 26,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428850,
                    hora: {
                        horas: 9,
                        minutos: 33,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428856,
                    hora: {
                        horas: 9,
                        minutos: 41,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428853,
                    hora: {
                        horas: 9,
                        minutos: 48,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428934,
                    hora: {
                        horas: 9,
                        minutos: 59,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428873,
                    hora: {
                        horas: 10,
                        minutos: 4,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428917,
                    hora: {
                        horas: 10,
                        minutos: 17,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428897,
                    hora: {
                        horas: 10,
                        minutos: 26,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428895,
                    hora: {
                        horas: 10,
                        minutos: 31,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428887,
                    hora: {
                        horas: 14,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428896,
                    hora: {
                        horas: 14,
                        minutos: 6,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428893,
                    hora: {
                        horas: 14,
                        minutos: 16,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428890,
                    hora: {
                        horas: 14,
                        minutos: 21,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428885,
                    hora: {
                        horas: 14,
                        minutos: 26,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428916,
                    hora: {
                        horas: 14,
                        minutos: 34,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428906,
                    hora: {
                        horas: 14,
                        minutos: 41,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428888,
                    hora: {
                        horas: 14,
                        minutos: 48,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428903,
                    hora: {
                        horas: 14,
                        minutos: 57,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428881,
                    hora: {
                        horas: 15,
                        minutos: 5,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428879,
                    hora: {
                        horas: 15,
                        minutos: 12,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428876,
                    hora: {
                        horas: 15,
                        minutos: 19,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428860,
                    hora: {
                        horas: 15,
                        minutos: 30,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428910,
                    hora: {
                        horas: 15,
                        minutos: 36,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428851,
                    hora: {
                        horas: 15,
                        minutos: 43,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428878,
                    hora: {
                        horas: 15,
                        minutos: 54,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428884,
                    hora: {
                        horas: 16,
                        minutos: 2,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428922,
                    hora: {
                        horas: 16,
                        minutos: 13,
                    },
                },
            ],
            startTime: {
                horas: 7,
                minutos: 0,
            },
        },
        '117096': {
            pedidos: [
                {
                    tipo: 'Cliente',
                    id: 162428898,
                    hora: {
                        horas: 9,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428864,
                    hora: {
                        horas: 9,
                        minutos: 59,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428912,
                    hora: {
                        horas: 10,
                        minutos: 15,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428931,
                    hora: {
                        horas: 10,
                        minutos: 34,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428891,
                    hora: {
                        horas: 11,
                        minutos: 9,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428869,
                    hora: {
                        horas: 14,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428865,
                    hora: {
                        horas: 16,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428936,
                    hora: {
                        horas: 16,
                        minutos: 19,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428924,
                    hora: {
                        horas: 16,
                        minutos: 48,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428921,
                    hora: {
                        horas: 16,
                        minutos: 59,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428909,
                    hora: {
                        horas: 17,
                        minutos: 29,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428863,
                    hora: {
                        horas: 19,
                        minutos: 37,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428927,
                    hora: {
                        horas: 21,
                        minutos: 56,
                    },
                },
            ],
            pedidosOrdenados: [
                {
                    tipo: 'Cliente',
                    id: 162428898,
                    hora: {
                        horas: 9,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428864,
                    hora: {
                        horas: 9,
                        minutos: 59,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428912,
                    hora: {
                        horas: 10,
                        minutos: 15,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428931,
                    hora: {
                        horas: 10,
                        minutos: 34,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428891,
                    hora: {
                        horas: 11,
                        minutos: 9,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428869,
                    hora: {
                        horas: 14,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428865,
                    hora: {
                        horas: 16,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428936,
                    hora: {
                        horas: 16,
                        minutos: 19,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428924,
                    hora: {
                        horas: 16,
                        minutos: 48,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428921,
                    hora: {
                        horas: 16,
                        minutos: 59,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428909,
                    hora: {
                        horas: 17,
                        minutos: 29,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428863,
                    hora: {
                        horas: 19,
                        minutos: 37,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428927,
                    hora: {
                        horas: 21,
                        minutos: 56,
                    },
                },
            ],
            startTime: {
                horas: 7,
                minutos: 0,
            },
        },
        '117106': {
            pedidos: [
                {
                    tipo: 'Cliente',
                    id: 162428858,
                    hora: {
                        horas: 9,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428915,
                    hora: {
                        horas: 9,
                        minutos: 6,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428855,
                    hora: {
                        horas: 9,
                        minutos: 15,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428862,
                    hora: {
                        horas: 9,
                        minutos: 32,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428868,
                    hora: {
                        horas: 9,
                        minutos: 38,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428932,
                    hora: {
                        horas: 9,
                        minutos: 43,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428870,
                    hora: {
                        horas: 9,
                        minutos: 48,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428937,
                    hora: {
                        horas: 9,
                        minutos: 55,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428892,
                    hora: {
                        horas: 10,
                        minutos: 6,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428883,
                    hora: {
                        horas: 10,
                        minutos: 12,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428889,
                    hora: {
                        horas: 10,
                        minutos: 20,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428938,
                    hora: {
                        horas: 10,
                        minutos: 31,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428928,
                    hora: {
                        horas: 10,
                        minutos: 40,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428867,
                    hora: {
                        horas: 10,
                        minutos: 45,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428929,
                    hora: {
                        horas: 10,
                        minutos: 50,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428852,
                    hora: {
                        horas: 11,
                        minutos: 1,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428914,
                    hora: {
                        horas: 11,
                        minutos: 20,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428880,
                    hora: {
                        horas: 11,
                        minutos: 34,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428842,
                    hora: {
                        horas: 14,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428905,
                    hora: {
                        horas: 14,
                        minutos: 22,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428872,
                    hora: {
                        horas: 15,
                        minutos: 25,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428933,
                    hora: {
                        horas: 15,
                        minutos: 30,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428875,
                    hora: {
                        horas: 15,
                        minutos: 36,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428877,
                    hora: {
                        horas: 16,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428926,
                    hora: {
                        horas: 16,
                        minutos: 8,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428857,
                    hora: {
                        horas: 16,
                        minutos: 19,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428849,
                    hora: {
                        horas: 16,
                        minutos: 27,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428848,
                    hora: {
                        horas: 16,
                        minutos: 32,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428845,
                    hora: {
                        horas: 16,
                        minutos: 38,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428920,
                    hora: {
                        horas: 16,
                        minutos: 51,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428939,
                    hora: {
                        horas: 16,
                        minutos: 59,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428907,
                    hora: {
                        horas: 17,
                        minutos: 5,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428923,
                    hora: {
                        horas: 17,
                        minutos: 13,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428861,
                    hora: {
                        horas: 17,
                        minutos: 21,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428904,
                    hora: {
                        horas: 17,
                        minutos: 29,
                    },
                },
            ],
            pedidosOrdenados: [
                {
                    tipo: 'Cliente',
                    id: 162428858,
                    hora: {
                        horas: 9,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428915,
                    hora: {
                        horas: 9,
                        minutos: 6,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428855,
                    hora: {
                        horas: 9,
                        minutos: 15,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428862,
                    hora: {
                        horas: 9,
                        minutos: 32,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428868,
                    hora: {
                        horas: 9,
                        minutos: 38,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428932,
                    hora: {
                        horas: 9,
                        minutos: 43,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428870,
                    hora: {
                        horas: 9,
                        minutos: 48,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428937,
                    hora: {
                        horas: 9,
                        minutos: 55,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428892,
                    hora: {
                        horas: 10,
                        minutos: 6,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428883,
                    hora: {
                        horas: 10,
                        minutos: 12,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428889,
                    hora: {
                        horas: 10,
                        minutos: 20,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428938,
                    hora: {
                        horas: 10,
                        minutos: 31,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428928,
                    hora: {
                        horas: 10,
                        minutos: 40,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428867,
                    hora: {
                        horas: 10,
                        minutos: 45,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428929,
                    hora: {
                        horas: 10,
                        minutos: 50,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428852,
                    hora: {
                        horas: 11,
                        minutos: 1,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428914,
                    hora: {
                        horas: 11,
                        minutos: 20,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428880,
                    hora: {
                        horas: 11,
                        minutos: 34,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428842,
                    hora: {
                        horas: 14,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428905,
                    hora: {
                        horas: 14,
                        minutos: 22,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428872,
                    hora: {
                        horas: 15,
                        minutos: 25,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428933,
                    hora: {
                        horas: 15,
                        minutos: 30,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428875,
                    hora: {
                        horas: 15,
                        minutos: 36,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428877,
                    hora: {
                        horas: 16,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428926,
                    hora: {
                        horas: 16,
                        minutos: 8,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428857,
                    hora: {
                        horas: 16,
                        minutos: 19,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428849,
                    hora: {
                        horas: 16,
                        minutos: 27,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428848,
                    hora: {
                        horas: 16,
                        minutos: 32,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428845,
                    hora: {
                        horas: 16,
                        minutos: 38,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428920,
                    hora: {
                        horas: 16,
                        minutos: 51,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428939,
                    hora: {
                        horas: 16,
                        minutos: 59,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428907,
                    hora: {
                        horas: 17,
                        minutos: 5,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428923,
                    hora: {
                        horas: 17,
                        minutos: 13,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428861,
                    hora: {
                        horas: 17,
                        minutos: 21,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428904,
                    hora: {
                        horas: 17,
                        minutos: 29,
                    },
                },
            ],
            startTime: {
                horas: 7,
                minutos: 0,
            },
        },
        '117112': {
            pedidos: [
                {
                    tipo: 'Cliente',
                    id: 162428844,
                    hora: {
                        horas: 9,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428859,
                    hora: {
                        horas: 9,
                        minutos: 12,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428871,
                    hora: {
                        horas: 9,
                        minutos: 21,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428935,
                    hora: {
                        horas: 9,
                        minutos: 33,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428874,
                    hora: {
                        horas: 9,
                        minutos: 38,
                    },
                },
            ],
            pedidosOrdenados: [
                {
                    tipo: 'Cliente',
                    id: 162428844,
                    hora: {
                        horas: 9,
                        minutos: 0,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428859,
                    hora: {
                        horas: 9,
                        minutos: 12,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428871,
                    hora: {
                        horas: 9,
                        minutos: 21,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428935,
                    hora: {
                        horas: 9,
                        minutos: 33,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428874,
                    hora: {
                        horas: 9,
                        minutos: 38,
                    },
                },
            ],
            startTime: {
                horas: 7,
                minutos: 0,
            },
        },
        '117115': {
            pedidos: [
                {
                    tipo: 'Cliente',
                    id: 162428919,
                    hora: {
                        horas: 23,
                        minutos: 8,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428913,
                    hora: {
                        horas: 23,
                        minutos: 15,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428866,
                    hora: {
                        horas: 23,
                        minutos: 26,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428930,
                    hora: {
                        horas: 23,
                        minutos: 36,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428894,
                    hora: {
                        horas: 23,
                        minutos: 43,
                    },
                },
            ],
            pedidosOrdenados: [
                {
                    tipo: 'Cliente',
                    id: 162428919,
                    hora: {
                        horas: 23,
                        minutos: 8,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428913,
                    hora: {
                        horas: 23,
                        minutos: 15,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428866,
                    hora: {
                        horas: 23,
                        minutos: 26,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428930,
                    hora: {
                        horas: 23,
                        minutos: 36,
                    },
                },
                {
                    tipo: 'Cliente',
                    id: 162428894,
                    hora: {
                        horas: 23,
                        minutos: 43,
                    },
                },
            ],
            startTime: {
                horas: 23,
                minutos: 0,
            },
        },
    },
    recurrente: 0,
    descripcion: '6807dcf4f3dbd',
    cost: 0,
    status: 1,
    gap: 0,
};
